import React, { Component } from 'react';
import Main from './components/main/component';
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    };

    componentWillMount(){
        //this.initializeReactGA();
        //this.initializeReactGA4();
    }

    initializeReactGA() {
        //ReactGA.initialize('UA-194332544-1');
    }

    initializeReactGA4() {
        //ReactGA4.initialize('G-6C7PY37NV0')
    }

    render() {
        return (
            <Main />
        )
    }

}

export default App



// WEBPACK FOOTER //
// ./src/App.js